import { AfterViewInit, ChangeDetectionStrategy, Component } from '@angular/core';
import { Salutation } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { SalutationService } from '../../services/salutation.service';

@Component({
  selector: 'app-salutation-drop-down',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SalutationDropDownComponent extends GenericBaseModelDropDown<Salutation> implements AfterViewInit {

  constructor(private service: SalutationService) {
    super(service, "Salutation");

  }
}